import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as userDataActions from '../../../actions/userDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as appConstants from '../../../constants/appConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as environmentHelper from '../../../helpers/environmentHelper';
import {CircularProgressbarWithChildren, buildStyles} from 'react-circular-progressbar';

class OptionAudioController extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            option: props.option,
            locale: appHelper.getLocalData(props.option),
            lang: this.props.lang,
            audio: {
                src: "",
            },
            id: "",
            status: objectConstants.CLASS_NOT_STARTED,
            play_label: appHelper.getLocaleString("play_label"),
            replay_label: appHelper.getLocaleString("replay_label"),
            pause_label: appHelper.getLocaleString("pause_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            audioIsPlaying: false,
            currentAudioId: props.currentAudioId,
            pauseIfPlaying: false,
            percentagePlayed: 0,
            browser: environmentHelper.getEnvironment().browser.name,
        };
        this.getAssetPath = this.getAssetPath.bind(this);
        this.playAudio = this.playAudio.bind(this);
        this.pauseAudio = this.pauseAudio.bind(this);
        this.playAudioOnKeyClick = this.playAudioOnKeyClick.bind(this);
        this.pauseAudioOnKeyClick = this.pauseAudioOnKeyClick.bind(this);
        this.getAssets = this.getAssets.bind(this);

        this.audioRef = React.createRef();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.lang !== nextProps.lang && appHelper.isDefined(nextProps.lang)) {
            return ({
                lang: nextProps.lang,
                play_label: appHelper.getLocaleString("play_label"),
                replay_label: appHelper.getLocaleString("replay_label"),
                pause_label: appHelper.getLocaleString("pause_label"),
                continue_label: appHelper.getLocaleString("continue_label"),
            });
        }

        if (prevState.currentAudioId !== nextProps.currentAudioId && appHelper.isDefined(nextProps.currentAudioId)) {
            return ({
                currentAudioId: nextProps.currentAudioId,
                pauseIfPlaying: prevState.audioIsPlaying && nextProps.currentAudioId !== prevState.id
            });
        }
    }

    componentDidMount() {
        this.getAssets();
    }

    componentDidUpdate() {
        if (this.state.pauseIfPlaying) {
            this.pauseAudio();
        }
    }

    getAssets() {
        if (appHelper.isDefined(this.state.option.option_audio) && appHelper.isDefined(this.state.locale.option_audio)) {
            let audio = appHelper.getAudioOptionAsset(this.state.locale.option_audio);
            if (appHelper.isDefined(this.state.option.option_audio.enabled) && this.state.option.option_audio.enabled) {
                this.setState({
                    audio: Object.assign({}, audio),
                    id: `${audio.id}_${audio.constant}`
                });
            }
        }
    }

    getAssetPath(asset) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(asset) && asset.length > 0) {
                return require(`../../../../moveToDist/${asset}`);
            }
        } else {
            return asset;
        }
    }

    playAudio(event) {
        if (appHelper.isDefined(event)) {
            event.preventDefault();
            event.stopPropagation();
        }
        let audioRef = this.audioRef.current;
        if (appHelper.isDefined(audioRef) && audioRef !== null) {
            //audioRef.currentTime = 0;
            this.setState({
                audioIsPlaying: true
            });
            audioRef.play();

            audioRef.onplay = function () {
                this.props.actions.setCurrentAudio(this.state.id);
                this.setState({
                    audioIsPlaying: true
                });
            }.bind(this);

            audioRef.ontimeupdate = function () {
                let currentTime = audioRef.currentTime;
                let duration = audioRef.duration;
                this.setState({percentagePlayed: (currentTime / duration) * 100});

            }.bind(this);

            audioRef.onended = function () {

                this.setState({
                    status: objectConstants.STATUS_COMPLETE,
                    audioIsPlaying: false,
                });
            }.bind(this);
        }
    }

    pauseAudio(event) {
        if (appHelper.isDefined(event)) {
            event.preventDefault();
            event.stopPropagation();
        }
        let audioRef = this.audioRef.current;
        if (appHelper.isDefined(audioRef) && audioRef !== null) {
            audioRef.pause();
            this.setState({audioIsPlaying: false, pauseIfPlaying: false});
        }

    }

    playAudioOnKeyClick(event) {
        if (appHelper.isDefined(event)) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.playAudio();
        }
    }

    pauseAudioOnKeyClick(event) {
        if (appHelper.isDefined(event)) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.pauseAudio();
        }
    }

    render() {
        return (

                <div className="audio-control-container">

                    {appHelper.isDefined(this.state.audio.id)
                        ?
                        <div className="audio-container">
                            {
                                appHelper.isDefined(this.state.browser) && (this.state.browser !== "Internet Explorer")
                                    ?
                                    <div className="circular-audio-control-container">
                                        <CircularProgressbarWithChildren value={this.state.percentagePlayed}>
                                            {
                                                !this.state.audioIsPlaying
                                                    ?
                                                    <div className={`audio-control play-btn`} onClick={this.playAudio}
                                                         onKeyDown={this.playAudioOnKeyClick} role="link" tabIndex="0"
                                                         aria-controls="playAudio"/>
                                                    :
                                                    null
                                            }

                                            {
                                                this.state.audioIsPlaying
                                                    ?
                                                    <div className={`audio-control pause-btn`} onClick={this.pauseAudio}
                                                         onKeyDown={this.pauseAudioOnKeyClick} role="link" tabIndex="0"
                                                         aria-controls="pauseAudio"/>
                                                    :
                                                    null
                                            }
                                        </CircularProgressbarWithChildren>
                                    </div>
                                    :
                                    <div>
                                        {
                                            !this.state.audioIsPlaying
                                                ?
                                                <div className={`audio-control play-btn`} onClick={this.playAudio}
                                                     onKeyDown={this.playAudioOnKeyClick} role="link" tabIndex="0"
                                                     aria-controls="playAudio"/>
                                                :
                                                null
                                        }

                                        {
                                            this.state.audioIsPlaying
                                                ?
                                                <div className={`audio-control pause-btn`} onClick={this.pauseAudio}
                                                     onKeyDown={this.pauseAudioOnKeyClick} role="link" tabIndex="0"
                                                     aria-controls="pauseAudio"/>
                                                :
                                                null
                                        }
                                    </div>
                            }
                        </div>
                        :
                        <div className="audio-container">
                            {
                                appHelper.isDefined(this.state.browser) && (this.state.browser !== "Internet Explorer")
                                    ?
                                    <div className="circular-audio-control-container">
                                        <CircularProgressbarWithChildren value={this.state.percentagePlayed}
                                                                         styles={buildStyles({
                                                                             pathColor: '#333',
                                                                             trailColor: 'rgba(0, 0, 0, 0.1)'
                                                                         })}>
                                            <div className={`audio-control disabled play-btn`}/>
                                        </CircularProgressbarWithChildren>
                                    </div>
                                    :
                                    <div className="flex-item">
                                        <div className={`audio-control play-btn disabled`} onClick={this.playAudio}
                                             onKeyDown={this.playAudioOnKeyClick} role="link" tabIndex="0"
                                             aria-controls="playAudio"/>
                                    </div>
                            }

                        </div>
                    }
                    <div className="flex-item">
                        {appHelper.isDefined(this.state.audio.id) && !this.state.audioIsPlaying
                            ?
                            <span>{this.state.play_label}</span>
                            : null
                        }
                        {appHelper.isDefined(this.state.audio.id) && this.state.audioIsPlaying
                            ?
                            <span>{this.state.pause_label}</span>
                            :
                            null
                        }
                        {!appHelper.isDefined(this.state.audio.id)
                            ?
                            <span className="disabled">{this.state.play_label}</span>
                            :
                            null
                        }
                    </div>
                    <div className="flex-item">
                        {this.state.audioIsPlaying
                            ?
                            <div className="audio-bars">
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                            </div>
                            :
                            <div
                                className={`static-audio-bars ${!appHelper.isDefined(this.state.audio.id) ? 'disabled' : ''}`}>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                                <div className="bar"/>
                            </div>
                        }
                    </div>

                    {appHelper.isDefined(this.state.audio.locale) && appHelper.isDefined(this.state.audio.locale[this.state.lang]) && appHelper.isDefined(this.state.audio.locale[this.state.lang].src)
                    ?
                        <audio ref={this.audioRef} src={this.getAssetPath(this.state.audio.locale[this.state.lang].src)}
                               preload="auto"/>
                        :
                        null
                    }
                </div>



        );
    }
}

OptionAudioController.propTypes = {
    option: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    currentAudioId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

OptionAudioController.contextTypes = {
    router: PropTypes.object
};


function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        currentAudioId: state.currentAudioId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OptionAudioController);



/** WEBPACK FOOTER **
 ** ./src/components/objects/audio/OptionAudioController.js
 **/